import WorkspaceView from "@cosy/components/WorkspaceView";
import { getLayout as getAppLayout } from "@cosy/layouts/App";

export default function WorkspaceHomePage() {
  return <WorkspaceView />;
}

WorkspaceHomePage.getLayout = getAppLayout;
